// extracted by mini-css-extract-plugin
export var saBoxes3Section = "saBoxes3-module--saBoxes3Section--1-71u";
export var saBoxesTitleContainer = "saBoxes3-module--saBoxesTitleContainer--2wVQC";
export var saBoxesTextContainer = "saBoxes3-module--saBoxesTextContainer--u7x20";
export var saBoxesBlocksItemTitle = "saBoxes3-module--saBoxesBlocksItemTitle--3ZWsK";
export var saBoxesBlocksItemText = "saBoxes3-module--saBoxesBlocksItemText--i3FG1";
export var saBoxesBtn = "saBoxes3-module--saBoxesBtn--55kMQ";
export var saBoxesBlocks = "saBoxes3-module--saBoxesBlocks--3lVHK";
export var saBoxesTitle = "saBoxes3-module--saBoxesTitle--2zQBR";